import { render, staticRenderFns } from "./GenAiGovernance.vue?vue&type=template&id=3a81ac9d&"
import script from "./GenAiGovernance.vue?vue&type=script&lang=ts&"
export * from "./GenAiGovernance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports